module.exports = __webpack_public_path__ + "static/media/6.0c0a08bd.jpg";